import { Helmet } from 'react-helmet-async'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule,
} from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useCurrentUser from '@hooks/useCurrentUser'
import useReporting, { generateUrls } from '@hooks/useReporting'

import handleCallbackAction from '@functions/handleCallbackAction'
import { getReportingPageAllowedReports } from '@functions/reporting'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import PageHeader from '@components/PageHeader'
import Reporting from '@components/Reporting'

const PageContent = () => {
  const currentUserPayload = useCurrentUser()
  const { currentUser } = currentUserPayload

  const { selectedAgencyId } = useAgencySelector()

  const reportingPayload = useReporting({
    allowedReports: getReportingPageAllowedReports(currentUserPayload),
    defaultValues: { brand_id: currentUser.brand_id, agency_id: selectedAgencyId },
  })

  const {
    callbacks: {
      generateReport: generateFn,
    },
    loading,
    saveEnabled,
  } = reportingPayload

  const { reportingIndexUrl } = generateUrls({ prefixRoute: `agencies/${selectedAgencyId}/manage` })

  const generateReportPayload = {
    callbacks: {
      action: generateFn,
    },
    toastText: 'Report Queued',
  }

  return (
    <>
      <Helmet>
        <title>Reporting | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="reporting"
        nestedNavigation
        tabBarItems={[
          {
            href: reportingIndexUrl,
            icon: faGlobe,
            key: 'reporting',
            title: 'REPORTING',
          },
        ]}
        title="Reporting"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.reporting.banner" />

            <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Generate Report">
              <Reporting reportingPayload={reportingPayload} />

              <DashboardModule.Footer>
                <DashboardModule.FooterRight>
                  <Button
                    buttonStyle="primaryEdit"
                    disabled={!saveEnabled}
                    loading={loading}
                    // @ts-expect-error TS2345
                    onClick={() => handleCallbackAction(generateReportPayload)}
                    size="medium"
                  >
                    Generate Report
                  </Button>
                </DashboardModule.FooterRight>
              </DashboardModule.Footer>
            </DashboardModule>
          </Columns.Main>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
